<template>
  <div id="app" class="u-flex">
    <main>
      <slot></slot>
    </main>
    <alerts></alerts>
  </div>
</template>
<script>
import alerts from '@/components/alerts';

export default {
  name: 'app',
  data() {
    return {
      user: []
    };
  },
  components: {
    alerts
  }
};
</script>



// WEBPACK FOOTER //
// src/layouts/simple.vue